import React, { useState } from 'react';
import { TextField, Autocomplete, Box } from '@mui/material';

const SearchSelect = ({
  options = [],
  value,
  onChange,
  label,
  searchKeys = ['name'],
  getOptionLabel,
  renderOption,
  placeholder = 'Search...',
  className,
  fullWidth = true,
  size = 'small',
  limit = 10,
  disabled = false,
  helperText,
  FormHelperTextProps,
}) => {
  const [filteredOptions, setFilteredOptions] = useState([]);

  const handleSearch = (event, searchValue, reason) => {
    if (reason === 'reset' || reason === 'clear' || !searchValue) {
      setFilteredOptions([]);
      return;
    }

    const searchTerm = searchValue.toLowerCase();

    let matchedItems = options.filter((item) => {
      return searchKeys.some((key) => {
        const itemValue = item[key];
        if (typeof itemValue === 'string') {
          return itemValue.toLowerCase().includes(searchTerm);
        }
        if (typeof itemValue === 'number') {
          return String(itemValue).toLowerCase().includes(searchTerm);
        }
        return false;
      });
    });

    matchedItems = matchedItems.sort((a, b) => {
      const aLower = (a.name || '').toLowerCase();
      const bLower = (b.name || '').toLowerCase();

      if (aLower.startsWith(searchTerm) && !bLower.startsWith(searchTerm)) {
        return -1;
      }
      if (!aLower.startsWith(searchTerm) && bLower.startsWith(searchTerm)) {
        return 1;
      }
      return aLower.localeCompare(bLower);
    });

    setFilteredOptions(matchedItems.slice(0, limit));
  };

  const defaultGetOptionLabel = (option) => {
    if (typeof option === 'string') return option;
    return option.name || '';
  };

  const defaultRenderOption = (props, option) => (
    <li {...props} key={option.id}>
      <Box style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
        <span>{option.name}</span>
      </Box>
    </li>
  );

  return (
    <Autocomplete
      options={filteredOptions.length > 0 ? filteredOptions : options.slice(0, limit)}
      isOptionEqualToValue={(option, val) => option === val || (option?.id && option?.id === val?.id)}
      getOptionLabel={getOptionLabel || defaultGetOptionLabel}
      renderOption={renderOption || defaultRenderOption}
      value={options.find((item) => item.id === value) || null}
      fullWidth={fullWidth}
      disableClearable
      disabled={disabled}
      className={className}
      onInputChange={handleSearch}
      onChange={(event, newValue) => onChange(newValue ? newValue.id : null)}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          fullWidth
          size={size}
          variant="outlined"
          placeholder={placeholder}
          InputProps={{
            ...params.InputProps,
            endAdornment: <>{params.InputProps.endAdornment}</>,
          }}
          InputLabelProps={{
            shrink: true,
          }}
          helperText={helperText}
          FormHelperTextProps={FormHelperTextProps}
        />
      )}
    />
  );
};

export default SearchSelect;
